import Swiper from 'swiper';
// import { getPosition, viewport } from '../helpers/helpers'

export default class Statistics {
	constructor(el) {
		this.el = el;
		this.sliderEl = this.el.querySelector('.numbers__slider');
		this.numbers = [...this.el.querySelectorAll('.number')];

		this.init();
		this.events();
	}

	init() {
		this.total = this.numbers.length;

		this.slider = new Swiper(this.sliderEl, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			centeredSlides: true,
			threshold: 10,
			effect: 'coverflow',
			grabCursor: true,
			coverflowEffect: {
				rotate: 0,
				stretch: 0,
				depth: 0,
				modifier: 1,
				slideShadows : false
			},
			slideActiveClass: 'number--active',
			slideNextClass: 'number--secondary',
			slidePrevClass: 'number--secondary',
			initialSlide: Math.floor((this.total - 1) / 2),
			pagination: {
				el: '.slider__pagination',
				clickable: true,
				bulletClass: 'slider__bullet',
				bulletActiveClass: 'slider__bullet--active'
			},
			breakpoints: {
				480: {
					initialSlide: 0,
				}
			}
		});

		this.updateNumberClasses();
	}

	events() {
		this.slider.on('slideChange', () => {
			this.updateNumberClasses();
		});

	}

	updateNumberClasses() {
		this.clearNumberClasses();
		let current = this.slider.realIndex;

		if (current > 1) {
			this.numbers[current - 2].classList.add('number--tertiary');
		}

		if (current < this.total - 2) {
			this.numbers[current + 2].classList.add('number--tertiary');
		}
	}

	clearNumberClasses() {
		this.numbers.forEach(el => {
			el.classList.remove('number--tertiary');
		});
	}


}